module.exports = __webpack_public_path__ + "img/icon_lock_gray.071a664.svg";